var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBolt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.262 2.866A.75.75 0 0 1 5 2.25h5a.75.75 0 0 1 .721.956L9.994 5.75H12.5a.75.75 0 0 1 .55 1.26l-6.5 7a.75.75 0 0 1-1.285-.657l.82-4.103H4a.75.75 0 0 1-.738-.884l1-5.5zm1.364.884-.727 4H7a.75.75 0 0 1 .735.897l-.48 2.398L10.78 7.25H9a.75.75 0 0 1-.721-.956l.727-2.544h-3.38z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBolt);
export default ForwardRef;